'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Box = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"], ["\n    width: 88px;\n    height: 88px;\n    img {\n        border-radius: 50%;\n        width: 88px;\n        height: 88px;\n        object-fit: cover;\n    }\n"])));
var templateObject_1;

export { Box };
//# sourceMappingURL=index.css.js.map
